/**
 * Ruta `/tareo` (008 · T056 · US2; contracts/ui.md §1.1 y §1.6): matriz trabajador × día evaluada
 * contra el horario, con su detalle por día y la descarga en Excel (US3).
 */
import { createFileRoute } from '@tanstack/react-router';

import { TimesheetPage } from '../../features/timesheet/timesheet-page';

export const Route = createFileRoute('/_app/tareo')({
  component: TimesheetPage,
});
